module.exports = __webpack_public_path__ + "static/img/main-visual-logo.75f96f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main-visual-logo.png
// module id = Ajy0
// module chunks = 1